// extracted by mini-css-extract-plugin
export default {"zoomLink":"styles_zoomLink__BOY1p"};